/* Olilu product page extras, loaded by sections/product-styled, product-complete and product-recs (runs once).
   [data-sby]  Styled by you / Out and about: each video plays muted while at least half of it is on screen; never with
               reduced motion.
   [data-pdc]  Complete the look: chooses pieces that go with this product (see the plan below), then shows their cards.
   [data-rv]   Recently viewed: earlier product pages from this browser (localStorage "olilu_recent"), newest first.
   Cards come from sections/product-complete.liquid rendered for each product (its <template data-pdc-self>).
   Quick add ("+" on a card): a one-variant piece goes straight into the basket and the basket drawer opens; a piece
   with sizes or colours (up to 12 in stock) opens a small chooser on the card; more than that is a link to the product
   page. */
(function () {
  'use strict';
  if (window.__oliluPdpExtras) return;
  window.__oliluPdpExtras = true;
  var O = window.Olilu;
  if (!O) return;
  var $ = O.$, $$ = O.$$;
  var ROOT = ((O.cfg.routes && O.cfg.routes.root) || '/').replace(/\/?$/, '/');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function split(s) { return String(s || '').split(',').filter(Boolean); }

  // Desktop arrows only when the rail has more than fits (e.g. one recently viewed piece, or five photos at 1440)
  function fitNav(wrap) {
    var list = wrap && $('[data-rail]', wrap), nav = wrap && $('.rail-nav', wrap);
    if (!list || !nav) return;
    function fit() { nav.hidden = list.scrollWidth <= list.clientWidth + 2; }
    window.requestAnimationFrame(fit);
    if (!wrap.__fit) { wrap.__fit = true; window.addEventListener('resize', function () { window.requestAnimationFrame(fit); }); }
  }

  /* ================================================================ Styled by you */
  function play(v) {
    try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) { /* stays on its poster */ }
  }
  O.ready('[data-sby]', function (sec) {
    fitNav($('[data-rail-wrap]', sec));
    var vids = $$('video[data-sby-video]', sec);
    if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v.__inView = e.isIntersecting && e.intersectionRatio >= 0.5;
        if (v.__inView && !document.hidden) play(v); else v.pause();
      });
    }, { threshold: [0, 0.5, 1] });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
    document.addEventListener('visibilitychange', function () {
      vids.forEach(function (v) { if (document.hidden || !v.__inView) v.pause(); else play(v); });
    });
  });

  /* ================================================================ Shared: rows and cards */
  // Rows from a collection or Shopify's recommendations: {h, f, sh[], st, c, a, ss, ct[], i}
  var rowCache = {};
  function rows(url) {
    if (!rowCache[url]) {
      rowCache[url] = O.section(url, 'product-complete').then(function (html) {
        var el = O.parse(html).querySelector('[data-pdc-rows]');
        var a = el ? JSON.parse(el.textContent) : [];
        return a.filter(Array.isArray).map(function (r, i) {
          return { h: r[0], f: r[1] || r[0], sh: split(r[2]), st: r[3] || '', c: r[4] || '', a: r[5] === 1, ss: r[6] === 1, ct: split(r[7]), i: i };
        });
      }).catch(function () { return []; });
    }
    return rowCache[url];
  }
  // A product's card (with its "+"), as HTML; '' when the product can't be shown
  var cardCache = {};
  function card(handle) {
    if (!cardCache[handle]) {
      cardCache[handle] = O.section(ROOT + 'products/' + encodeURIComponent(handle), 'product-complete').then(function (html) {
        var t = O.parse(html).querySelector('template[data-pdc-self]');
        return t ? t.innerHTML : '';
      }).catch(function () { return ''; });
    }
    return cardCache[handle];
  }
  var uid = 0;
  function put(list, htmls) {
    list.innerHTML = htmls.filter(Boolean).join('');
    // The same product can sit in two rails: keep every chooser id unique
    $$('[data-pdc-opts]', list).forEach(function (p) {
      var id = p.id + '-' + (++uid);
      var b = p.parentNode.querySelector('[data-pdc-choose]');
      p.id = id;
      if (b) b.setAttribute('aria-controls', id);
    });
    list.removeAttribute('aria-busy');
    list.scrollLeft = 0;
    // olilu.js sets the arrows' disabled state on scroll
    list.dispatchEvent(new Event('scroll'));
    fitNav(list.closest('[data-rail-wrap]'));
    return list.children.length;
  }

  /* ================================================================ Complete the look */
  /* Plan by category: [collection, how many, style rule, leave out this cat]. 'other' = a different style only (a second
     glove style), 'prefer' = a different style first. The hats collection also holds the snood hats (cat:neckwear), so
     hat buckets leave those out (a snood comes from scarves-snoods). Buckets are interleaved so the first cards show a
     mix. Children's pieces (cat:kids) only appear on children's pages, and those keep to children's pieces and gifts. */
  var PLAN = {
    gloves: [['hats', 3, '', 'neckwear'], ['socks', 2], ['gloves', 2, 'other'], ['scarves-snoods', 1]],
    hats: [['gloves', 3], ['scarves-snoods', 2], ['socks', 2], ['hats', 1, 'other', 'neckwear']],
    neckwear: [['hats', 3, '', 'neckwear'], ['gloves', 3], ['socks', 2]],
    'scarves-shawls': [['hats', 3, '', 'neckwear'], ['gloves', 3], ['socks', 2]],
    socks: [['gloves', 3], ['hats', 3, '', 'neckwear'], ['socks', 1, 'other']],
    ponchos: [['gloves', 3], ['hats', 3, '', 'neckwear'], ['scarves-snoods', 1], ['socks', 1]],
    jumpers: [['gloves', 3], ['hats', 3, '', 'neckwear'], ['socks', 2]],
    kids: [['childrens-hats', 2], ['kids', 4, 'prefer'], ['alpaca-toys', 2, 'prefer']],
    gifts: [['alpaca-toys', 3, 'prefer'], ['christmas-decorations', 2, 'prefer'], ['gloves', 3]]
  };
  // At most two pieces of one style in a rail, and one pair of leg warmers (the socks collection holds them too)
  var CAP = { 'leg-warmers': 1 };
  var NEUTRAL = { naturals: 1, 'greys-black': 1 };
  var GENERIC = /^(and|light|dark|pale|soft|deep|bright|dusty|baby|mid|hot|the|with|colours?|assorted|choose|from)$/;
  function words(c) {
    return String(c || '').toLowerCase().split(/[^a-z]+/).filter(function (w) { return w.length > 2 && !GENERIC.test(w); });
  }
  /* Colour match: a shared colour family counts most, shared neutrals a little, a piece in neutrals only goes with
     anything, other bright families count against, and a shared colour word ("Teal", "Grey") counts extra. */
  function score(cur, r) {
    var s = 0, bright = 0, shared = 0, neutral = false;
    r.sh.forEach(function (x) {
      var mine = cur.sh.indexOf(x) > -1;
      if (x === 'multicolour') { if (mine) s += 1; return; }
      if (NEUTRAL[x]) { neutral = true; if (mine) s += 1; return; }
      bright++;
      if (mine) { s += 3; shared++; }
    });
    if (!bright && neutral) s += 1.5;
    s -= (bright - shared) * (shared ? 0.5 : 1);
    var w = words(r.c);
    if (cur.w.some(function (x) { return w.indexOf(x) > -1; })) s += 2;
    return s - r.i * 0.004; // best-sellers first when equal
  }
  function pick(cur, list, n, rule, used, ssOnly, notCat) {
    var c = list.filter(function (r) {
      return r.a && r.h !== cur.h && r.f !== cur.f && !cur.ex[r.h] && !used[r.f] && (!ssOnly || r.ss) &&
        (cur.kids ? (r.ct.indexOf('kids') > -1 || r.ct.indexOf('gifts') > -1) : r.ct.indexOf('kids') < 0) &&
        !(notCat && r.ct.indexOf(notCat) > -1) &&
        !(rule === 'other' && cur.st && r.st === cur.st);
    }).map(function (r) {
      return { r: r, s: score(cur, r) + (rule === 'prefer' && r.st !== cur.st ? 2 : 0) };
    });
    c.sort(function (a, b) { return b.s - a.s; });
    var out = [];
    for (var i = 0; i < c.length && out.length < n; i++) {
      var r = c[i].r, k = '#' + r.st;
      if (used[r.f] || (r.st && (used[k] || 0) >= (CAP[r.st] || 2))) continue;
      used[r.f] = true;
      if (r.st) used[k] = (used[k] || 0) + 1;
      out.push(r.h);
    }
    return out;
  }
  function interleave(buckets, limit) {
    var out = [], most = Math.max.apply(null, buckets.map(function (b) { return b.length; }).concat(0));
    for (var i = 0; i < most; i++) buckets.forEach(function (b) { if (b[i] && out.length < limit) out.push(b[i]); });
    return out;
  }

  O.ready('[data-pdc]', function (sec) {
    var d = sec.dataset;
    var list = $('[data-pdc-list]', sec);
    if (!list || !d.handle) return;
    var cur = { h: d.handle, f: d.family || d.handle, st: d.style || '', sh: split(d.shades), w: words(d.colour), ex: {}, kids: d.cat === 'kids' };
    split(d.exclude).forEach(function (h) { cur.ex[h] = true; });
    var ssOnly = d.ss === '1', limit = Number(d.limit) || 8;
    var plan = PLAN[d.cat] || [['gloves', 3], ['hats', 3], ['socks', 2]];
    function recs(intent) {
      return rows(ROOT + 'recommendations/products?product_id=' + d.pid + '&limit=10&intent=' + intent);
    }
    O.inView(sec, function () {
      Promise.all(plan.map(function (b) { return rows(ROOT + 'collections/' + b[0] + '?sort_by=best-selling'); }))
        .then(function (lists) {
          var used = {};
          used[cur.f] = true;
          var picks = interleave(plan.map(function (b, i) { return pick(cur, lists[i], b[1], b[2], used, ssOnly, b[3]); }), limit);
          if (picks.length >= 4) return picks;
          // Too few colour matches: Shopify's own suggestions fill the rail
          return recs('complementary').then(function (a) {
            picks = picks.concat(pick(cur, a, limit - picks.length, null, used, ssOnly));
            if (picks.length >= 4) return picks;
            return recs('related').then(function (b) { return picks.concat(pick(cur, b, limit - picks.length, null, used, ssOnly)); });
          });
        })
        .then(function (picks) { return Promise.all(picks.map(card)); })
        .then(function (htmls) { if (put(list, htmls) < 2) sec.hidden = true; })
        .catch(function () { sec.hidden = true; });
    }, '800px');
  });

  /* ================================================================ Recently viewed */
  var KEY = 'olilu_recent';
  function readRecent() {
    try { var a = JSON.parse(window.localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string'; }) : []; } catch (e) { return []; }
  }
  function writeRecent(a) {
    try { window.localStorage.setItem(KEY, JSON.stringify(a.slice(0, 16))); } catch (e) { /* private window: nothing kept */ }
  }
  O.ready('[data-rv]', function (sec) {
    var h = sec.getAttribute('data-handle'), limit = Number(sec.getAttribute('data-limit')) || 8;
    if (!h) return;
    var prev = readRecent().filter(function (x) { return x !== h; });
    writeRecent([h].concat(prev));
    if (!prev.length) return;
    // The section is hidden until filled, so watch its wrapper
    O.inView(sec.parentNode || sec, function () {
      var want = prev.slice(0, limit);
      Promise.all(want.map(card)).then(function (htmls) {
        var gone = want.filter(function (x, i) { return !htmls[i]; });
        if (gone.length) writeRecent(readRecent().filter(function (x) { return gone.indexOf(x) < 0; }));
        if (!htmls.some(Boolean)) return;
        sec.hidden = false;
        put($('[data-rv-list]', sec), htmls);
      });
    }, '800px');
  });

  /* ================================================================ Quick add */
  function closeOpts(item, focusBack) {
    var p = item && $('[data-pdc-opts]', item);
    if (!p || p.hidden) return;
    p.hidden = true;
    var b = $('[data-pdc-choose]', item);
    if (b) { b.setAttribute('aria-expanded', 'false'); if (focusBack) b.focus(); }
  }
  function openOpts(item) {
    $$('[data-pdc-item]').forEach(function (x) { if (x !== item) closeOpts(x, false); });
    var p = $('[data-pdc-opts]', item), b = $('[data-pdc-choose]', item);
    if (!p) return;
    p.hidden = false;
    if (b) b.setAttribute('aria-expanded', 'true');
    var f = $('[data-pdc-variant]', p);
    if (f) f.focus({ preventScroll: true });
  }
  function say(item, text) {
    var sec = item.closest('.pdc'), st = sec && $('[data-pdc-status]', sec);
    if (st) st.textContent = text;
  }
  function add(item, src, id, name) {
    var btn = $('.pdc__add', item) || src;
    if (!id || btn.classList.contains('is-loading')) return;
    var err = $('[data-pdc-error]', item);
    if (err) err.hidden = true;
    btn.classList.add('is-loading');
    src.setAttribute('aria-disabled', 'true');
    O.cart.add([{ id: Number(id), quantity: 1 }]).then(function () {
      closeOpts(item, false);
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      src.removeAttribute('aria-disabled');
      say(item, (name || 'The piece') + ' is in your basket.');
      O.basket.open(btn);
      setTimeout(function () { btn.classList.remove('is-added'); }, 2400);
    }).catch(function (e) {
      btn.classList.remove('is-loading');
      src.removeAttribute('aria-disabled');
      if (err) {
        err.textContent = (e && e.message && e.message !== 'Something went wrong') ? e.message : 'Sorry, that could not be added. Please try again.';
        err.hidden = false;
      }
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pdc-add], [data-pdc-choose], [data-pdc-variant], [data-pdc-close]');
    var openPanel = $('[data-pdc-opts]:not([hidden])');
    // A tap anywhere outside the open chooser (and its "+") closes it; a tap inside it, between buttons, does not
    if (openPanel && !openPanel.parentNode.contains(e.target)) closeOpts(openPanel.closest('[data-pdc-item]'), false);
    if (!t || !t.closest('.pdc')) return;
    var item = t.closest('[data-pdc-item]');
    if (!item) return;
    if (t.hasAttribute('data-pdc-choose')) {
      if (t.getAttribute('aria-expanded') === 'true') closeOpts(item, true); else openOpts(item);
      return;
    }
    if (t.hasAttribute('data-pdc-close')) { closeOpts(item, true); return; }
    add(item, t, t.getAttribute('data-pdc-variant') || t.getAttribute('data-variant'), t.getAttribute('data-name'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var p = $('[data-pdc-opts]:not([hidden])');
    if (p) closeOpts(p.closest('[data-pdc-item]'), true);
  });
})();
